// import CadencierService from '@/services/CadencierService'

import moment from 'moment'
import { v4 as uuid } from 'uuid'
import CommandeUtils from '@/utils/commandeUtils'
import CommonUtils from '@/utils/commonUtils'
import SentenceUtils from '@/utils/sentenceUtils'
import { CommandesService } from '../services/CommandesServicePoisson'
import { PlateauProductAnnexService } from '../services/PlateauProductAnnexService'
import { PlateauProductService } from '../services/PlateauProductService'
import { PlateauService } from '../services/PlateauService'


export const KEYBOARD_ACTION_COMMANDE = 'setCurrentCodeCommande'
export const KEYBOARD_VALIDATE_ACTION_COMMANDE = 'validateCurrentCodeCommande'
export const KEYBOARD_ACTION_PLATEAU = 'setCurrentCodePlateau'
export const KEYBOARD_VALIDATE_ACTION_PLATEAU = 'validateCurrentCodePlateau'
export const KEYBOARD_ACTION_PLATEAU_EDIT = 'setCurrentCodePlateauEdit'
export const KEYBOARD_VALIDATE_ACTION_PLATEAU_EDIT = 'validateCurrentCodePlateauEdit'
export const state = {
  loading: false,
  commande: [],
  commandes: [],
  groupedCommands: [],
  summary: [],
  currentCode: {},
  summaryWithoutCoeff: [],
  date: null,
  lieux: [],
  products: [],
  deletedProducts: [],
  productsType: [],
  plateaux: [],
  plateauxList: [],
  plateauxProductList: [],
  plateauxProductAnnexList: [],
  productAnnex: [],
  catalogPlateaux: [],
  customPlateaux: [],
  conditionnements: [],
  employees: [],
  livraisonRule: [],
  calendar: [],
  printed: [],
  shift: false,
  displayCommande: false,
  plateauSize: [],
  customers: [],
  tempsLivraison: [],
  conditionnementVente: [],
  conditionnementCommande: [],
  selectedPlateau: {},
  loadingPlateau: false,
  savingCommande: false,
  modalNewPlateau: false,
  fromPlateau: false,
  plateauCount: 0,
  internalProductList: [],
  civ: '',
}

export const mutations = {
  [KEYBOARD_ACTION_COMMANDE](currentState, code) {
    currentState.commande.currentCode = code
  },
  [KEYBOARD_ACTION_PLATEAU](currentState, code) {
    currentState.commande.currentCode = code
  },
  [KEYBOARD_ACTION_PLATEAU_EDIT](currentState, code) {
    currentState.commande.currentCode = code
  },
  setSummary(currentState, summary) {
    currentState.commande.summary = summary
  },
  setSummaryWithoutCoeff(currentState, summary) {
    currentState.commande.summaryWithoutCoeff = summary
  },
  setCalendar(currentState, calendar) {
    currentState.commande.calendar = calendar
  },
  setCurrentCommande(currentState, commande) {
    currentState.commande.commande = commande
  },
  setCommandesLoading(currentState, loading) {
    currentState.commande.loading = loading
  },
  setCommandesOnUpdate(currentState, commandes) {
    currentState.commande.commandes = commandes
  },
  setCommandes(currentState, commandes) {
    currentState.commande.commandes = commandes.commandes
    currentState.commande.date = commandes.date || currentState.commande.date
  },
  setLieux(currentState, commandes) {
    currentState.commande.lieux = commandes.lieux
  },
  setPlateaux(currentState, commandes) {
    currentState.commande.plateaux = commandes.plateaux
  },
  setCatalogPlateaux(currentState, commandes) {
    currentState.commande.catalogPlateaux = commandes.catalogPlateaux
  },
  setCustomPlateaux(currentState, commandes) {
    currentState.commande.customPlateaux = commandes.customPlateaux
  },
  setLivraisonRule(currentState, commandes) {
    currentState.commande.livraisonRule = commandes.rule.lieuLivraison
  },
  setConditionnements(currentState, commandes) {
    currentState.commande.conditionnements = commandes.conditionnements
  },
  setEmployees(currentState, commandes) {
    currentState.commande.employees = commandes.employees
  },
  setShift(currentState, commandes) {
    currentState.commande.shift = commandes.shift
  },
  setPrinted(currentState, commandes) {
    currentState.commande.printed = commandes || []
  },
  setGroupedCommands(currentState, commandes) {
    currentState.commande.groupedCommands = commandes || []
  },
  setPlateauSize(currentState, plateauSize) {
    currentState.commande.plateauSize = plateauSize
  },
  setDisplayCommande(currentState, displayCommande) {
    currentState.commande.displayCommande = displayCommande
  },
  setCustomers(currentState, customers) {
    currentState.commande.customers = customers
  },
  setTempsLivraison(currentState, tempsLivraison) {
    currentState.commande.tempsLivraison = tempsLivraison
  },
  setNewCommande(currentState, commande) {
    currentState.commande.commande = commande
  },
  setProducts(currentState, products) {
    currentState.commande.products = products
  },
  setDeletedProducts(currentState, deletedProducts) {
    currentState.commande.deletedProducts = deletedProducts
  },
  setProductsType(currentState, productsType) {
    currentState.commande.productsType = productsType
  },
  setCondtionnementVente(currentState, conditionnementVente) {
    currentState.commande.conditionnementVente = conditionnementVente
  },
  setCondtionnementCommande(currentState, conditionnementCommande) {
    currentState.commande.conditionnementCommande = conditionnementCommande
  },
  setPlateauxList(currentState, plateauxList) {
    currentState.commande.plateauxList = plateauxList
  },
  setPlateauCount(currentState, count) {
    currentState.commande.plateauCount = count
  },
  setPlateauxProductList(currentState, plateauxProductList) {
    currentState.commande.plateauxProductList = plateauxProductList
  },
  setPlateauxProductAnnexList(currentState, plateauxProductAnnexList) {
    currentState.commande.plateauxProductAnnexList = plateauxProductAnnexList
  },
  setProductAnnexForCommande(currentState, productAnnex) {
    currentState.commande.productAnnex = productAnnex
  },
  setSelectedPlateau(currentState, selectedPlateau) {
    currentState.commande.selectedPlateau = selectedPlateau
  },
  setLoadingPlateau(currentState, loadingPlateau) {
    currentState.commande.loadingPlateau = loadingPlateau
  },
  setSavingCommande(currentState, savingCommande) {
    currentState.commande.savingCommande = savingCommande
  },
  setModalPlateau(currentState, modalNewPlateau) {
    currentState.commande.modalNewPlateau = modalNewPlateau
  },
  setCiv(currentState, civ) {
    currentState.commande.civ = civ
  },
  setFromPlateau(currentState, fromPlateau) {
    currentState.commande.fromPlateau = fromPlateau
  },
  groupProductList(currentState, internalProductList) {
    currentState.commande.internalProductList = internalProductList
  },
}

export const actions = {
  [KEYBOARD_ACTION_PLATEAU]({ commit }, code) {
    commit(KEYBOARD_ACTION_PLATEAU, code)
  },
  [KEYBOARD_ACTION_COMMANDE]({ commit }, code) {
    commit(KEYBOARD_ACTION_COMMANDE, code)
  },
  [KEYBOARD_ACTION_PLATEAU_EDIT]({ commit }, code) {
    commit(KEYBOARD_ACTION_PLATEAU_EDIT, code)
  },
  [KEYBOARD_VALIDATE_ACTION_PLATEAU]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.commande.plateauxProductList.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({ ...product, value: { ...product.value, code: codeValue.code } })
      }
      return product
    })
    commit('setPlateauxProductList', foundProduct)
  },
  [KEYBOARD_VALIDATE_ACTION_PLATEAU_EDIT]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.commande.plateauxProductList.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({ ...product, value: { ...product.value, code: codeValue.code } })
      }
      return product
    })
    commit('setPlateauxProductList', foundProduct)
  },

  [KEYBOARD_VALIDATE_ACTION_COMMANDE]({ commit, rootState }, codeValue) {
    const foundProduct = rootState.commande.products.map(product => {
      if (product.value._id === codeValue.uuid) {
        return ({ ...product, value: { ...product.value, code: codeValue.code } })
      }
      return product
    })
    commit('setProducts', foundProduct)
  },
  addProduct({ commit, rootState }) {
    const products = CommonUtils.addToDictionnary(rootState.commande.products, {
      _id: uuid(),
      code: {},
      idConditionnementVente: 2,
      idTempsLivraison: 4,
      quantite: 0,
      codesCommande: [],
      deleted: false,
    })
    commit('setProducts', products)
  },
  addPlateauProduct({ commit, rootState }, product) {
    const products = rootState.commande.plateauxProductList.concat(product)
    commit('setPlateauxProductList', products)
  },
  removeProduct({ commit, rootState }, id) {
    const productsFiltered = rootState.commande.products.filter(product => product.key !== id)
    const deletedProductsFiltered = rootState.commande.deletedProducts.concat(rootState.commande.products.filter(product => product.key === id))
    commit('setDeletedProducts', deletedProductsFiltered)
    commit('setProducts', productsFiltered)
  },
  setCodeConditionnementCommande({ commit, rootState }, value) {
    const productsWithCond = rootState.commande.products.map(product => {
      if (product.key === value.key) {
        return ({ ...product, value: { ...product.value, codesCommande: value.selected } })
      }
      return product
    })
    commit('setProducts', productsWithCond)
  },
  loadPlateauSize({ commit }) {
    CommandesService.loadPlateauSize().then((plateauSize) => {
      commit('setPlateauSize', plateauSize)
    })
  },
  insertPlateauSize({ rootState, commit }, plateauxSize) {
    if (plateauxSize.length) {
      return CommandesService.insertPlateauCommandeSize(plateauxSize).then(() => {
        const commandesWithInsertedPlateau = rootState.commande.commandes.map(commande => {
          if (commande._id === plateauxSize[0].idCommande) return { ...commande, plateauSizeCommande: plateauxSize }
          return commande
        })
        const commandesWithDefaultPlateauSize = CommandesService.processPlateauSize(commandesWithInsertedPlateau, rootState.commande.plateauSize, [...rootState.commande.customPlateaux, ...rootState.commande.catalogPlateaux])


        commit('setCommandes', { commandes: commandesWithDefaultPlateauSize })
      })
    }
    return Promise.resolve
  },
  deletePlateauSize({ commit, rootState }, plateauxSize) {
    if (plateauxSize.length) {
      return CommandesService.deletePlateauCommande(plateauxSize).then(() => {
        const commandesWithInsertedPlateau = rootState.commande.commandes.map(commande => {
          if (commande._id === plateauxSize[0].idCommande) return { ...commande, plateauSizeCommande: [] }
          return commande
        })
        const commandesWithDefaultPlateauSize = CommandesService.processPlateauSize(commandesWithInsertedPlateau, rootState.commande.plateauSize, [...rootState.commande.customPlateaux, ...rootState.commande.catalogPlateaux])

        commit('setCommandes', {
          commandes: commandesWithDefaultPlateauSize,
        })
      })
    }
    return Promise.resolve
  },
  generateProductList({ commit }, commandes) {
    CommandesService.groupCommandes(commandes).then(groupedCommande => {
      commit('groupProductList', groupedCommande.commandes)
    })
  },
  groupCommandes({ commit }, commandes) {
    CommandesService.groupCommandes(commandes).then(groupedCommande => {
      commit('setGroupedCommands', groupedCommande.commandes)
      commit('setSummary', groupedCommande.total)
      commit('setSummaryWithoutCoeff', groupedCommande.totalWithoutCoeff)
    })
  },
  loadCalendar(
    { commit },
    date = moment()
      .add(1, 'day')
      .format('YYYY-MM-DD'),
  ) {
    return CommandesService.getByMonth(date, date).then(calendar => {
      commit('setCalendar', calendar)
    })
  },
  setPrinted({ commit }, commandes) {
    CommandesService.setPrinted(commandes).then(() => {
      CommandesService.getPrinted().then(commandes => {
        commit('setPrinted', commandes)
      })
    })
  },
  showCommande({ commit, dispatch, rootState }, showValue) {
    if (rootState.commande.commande._id && !showValue) {
      dispatch('resetCommande')
    }
    commit('setDisplayCommande', showValue)
  },
  setPlateauxList({ commit }, plateaux) {
    commit('setPlateauxList', plateaux)
  },
  resetCommande({ commit, dispatch }) {
    dispatch('loadNewCommande')
    commit('setProducts', [])
    commit('setCiv', '')
    commit('setPlateauxList', [])
    commit('setPlateauxProductList', [])
    commit('setPlateauxProductAnnexList', [])
  },
  selectPlateau({ commit }, idPlateau) {
    commit('setSelectedPlateau', idPlateau)
  },
  setLoadingPlateau({ commit }, boolean) {
    commit('setLoadingPlateau', boolean)
  },
  setSavingCommande({ commit }, boolean) {
    commit('setSavingCommande', boolean)
  },
  setModalPlateau({ commit }, boolean) {
    commit('setModalPlateau', boolean)
  },
  loadPrinted({ commit }) {
    CommandesService.getPrinted().then(commandes => {
      commit('setPrinted', commandes)
    })
  },
  updateEmployee({ commit, rootState }, employee) {
    commit('setCurrentCommande', { ...rootState.commande.commande, idEmployees: employee })
  },
  updateCiv({ commit, rootState }, civValue) {
    // Force CIV to commande value and handle prenom behavior
    commit('setCurrentCommande', { ...rootState.commande.commande, civ: civValue, prenom: civValue ? '' : rootState.commande.commande.prenom })
    commit('setCiv', civValue)
  },
  getPlateauList({ commit }) {
    PlateauService.getPlateaux()
      .then((plateaux) => {
        const plateauxEntries = plateaux.filter(plateau => !plateau.custom).map(plateau => CommonUtils.createDictionnaryEntry({
          ...plateau, idPlateau: plateau._id, _id: undefined, quantite: 0,
        }))
        commit('setPlateauCount', plateauxEntries.length)
        commit('setPlateauxList', plateauxEntries)
      })
  },
  setProductsEmpty({ commit }) {
    commit('setProducts', [])
  },
  setPlateauxProductEmptyList({ commit }) {
    commit('setPlateauxProductList', [])
  },
  setFromPlateau({ commit }, value) {
    commit('setFromPlateau', value)
  },
  setPlateauxProductAnnexEmptyList({ commit }) {
    commit('setPlateauxProductAnnexList', [])
  },
  getPlateauProductList({ commit, rootState }, idPlateau) {
    return PlateauProductService.getPlateauProducts(idPlateau)
      .then((plateauxProducts) => {
        const productList = plateauxProducts.map((product) => CommonUtils.createDictionnaryEntry({
          code: {
            idCode: product.idCode,
            idDenomination: product.idDenomination,
          },
          quantite: product.quantite,
          idConditionnementVente: product.idConditionnementVente,
          lastUpdate: product.lastUpdate,
          idPlateau: product.idPlateau,
          deleted: product.deleted,
          auxiliaire: product.auxiliaire,
          productOrder: product.productOrder,
          textConditionnementVente: rootState.commande.conditionnementVente.find(cv => cv.idConditionnementVente === product.idConditionnementVente).nom,
          active: true,
          _id: product._id,
          annex: false,
        })).sort((a, b) => a.value.productOrder - b.value.productOrder)
        commit('setPlateauxProductList', productList)
      })
  },
  getPlateauProductAnnexListForCommand({ commit, rootState }, idPlateau) {
    return PlateauProductAnnexService.getPlateauProductsAnnex(idPlateau)
      .then((plateauxProductsAnnex) => {
        const productAnnexList = plateauxProductsAnnex.map((productAnnex) => CommonUtils.createDictionnaryEntry({
          text: rootState.commande.productAnnex.filter(productAnnexBase => productAnnexBase.value._id === productAnnex.idProductAnnex)[0].value.nom,
          quantite: productAnnex.quantite,
          lastUpdate: productAnnex.lastUpdate,
          idPlateau: productAnnex.idPlateau,
          idProductAnnex: productAnnex.idProductAnnex,
          deleted: productAnnex.deleted,
          productOrder: productAnnex.productOrder,
          _id: productAnnex._id,
          active: true,
          annex: true,
        })).sort((a, b) => a.value.productOrder - b.value.productOrder)
        commit('setPlateauxProductAnnexList', productAnnexList)
        commit('setLoadingPlateau', false)
      })
  },
  getProductAnnexListForCommand({ commit }) {
    return PlateauService.getProductAnnex()
      .then((productsAnnex) => {
        const productsAnnexEntries = productsAnnex.map(productAnnex => CommonUtils.createDictionnaryEntry({ ...productAnnex, quantite: 0, idProductAnnex: productAnnex._id }))
        commit('setProductAnnexForCommande', productsAnnexEntries)
      })
  },
  getPlateauType({ commit }) {
    return PlateauService.getPlateauType()
      .then((productsType) => {
        commit('setProductsType', productsType.sort((a, b) => a.productOrder - b.productOrder).map(item => CommonUtils.createDictionnaryEntry({
          ...item, code: { idCode: item.idCode, idCodeMagasin: item.idCodeMagasin }, defaultQuantite: item.quantite, product_id: item._id, deleted: CommonUtils.toBoolean(item.deleted),
        })))
      })
  },
  setPlateauCount({ commit }, count) {
    commit('setPlateauCount', count)
  },
  setPlateauQuantite({ commit, rootState }, plateauValue) {
    const plateauxListFiltered = rootState.commande.plateauxList.map((plateau) => {
      if (plateau.value.idPlateau === plateauValue.idPlateau) {
        return ({ ...plateau, value: { ...plateau.value, quantite: plateauValue.quantite } })
      }
      return plateau
    })
    commit('setPlateauxList', plateauxListFiltered)
  },
  loadNewCommande({ commit }, date) {
    const newCommande = {
      idEmployees: {},
      nom: '',
      date: moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
      heure: moment().format('HH:00'),
      prenom: '',
      telephone: '',
      public: true,
      ready: false,
      deleted: false,
      deletedBy: '',
      commentaires: '',
      accompte: '0',
      auxiliaire: 9,
      idLieuLivraison: 1,
    }
    commit('setNewCommande', newCommande)
  },
  loadDefaultCommandeData({ commit, dispatch }) {
    return Promise.all([
      CommandesService.getCustomersList(),
      CommandesService.getTempsLivraison(),
      CommandesService.getConditionnementVente(),
      CommandesService.getConditionnementCommande(),
    ]).then((datas) => {
      dispatch('getProductAnnexListForCommand')
      commit('setCustomers', datas[0])
      commit('setTempsLivraison', datas[1])
      commit('setCondtionnementVente', datas[2])
      commit('setCondtionnementCommande', datas[3])
    })
  },
  loadCommandes(
    { commit, rootState },
    date = moment()
      .add(1, 'day')
      .format('YYYY-MM-DD'),
  ) {
    Promise.all([
      CommandesService.loadPlateauSize(),
      CommandesService.getCommandes(date),
    ]).then(commandesDatas => {
      const commandes = commandesDatas[1]
      const commandesWithDefaultPlateauSize = CommandesService.processPlateauSize(commandes.commandes, commandesDatas[0], [...commandes.customPlateaux, ...commandes.catalogPlateaux])
      commit('setCommandes', {
        commandes: commandesWithDefaultPlateauSize.map(c => ({ ...c, idEnregistrement: `${moment(c.dateLivraison, 'YYYY-MM-DD HH:mm:ss').format('DD')} - ${c.idEnregistrement}` })),
        date,
      })
      commit('setLivraisonRule', {
        rule: commandes.livraisonRule,
      })
      commit('setLieux', {
        lieux: commandes.lieux,
      })
      commit('setPlateaux', {
        plateaux: commandes.plateauxCatalog,
      })
      commit('setCustomPlateaux', {
        customPlateaux: commandes.customPlateaux,
      })
      commit('setCatalogPlateaux', {
        catalogPlateaux: commandes.catalogPlateaux,
      })
      commit('setConditionnements', {
        conditionnements: commandes.conditionnements,
      })
      commit('setEmployees', {
        employees: commandes.employees,
      })
      commit('setShift', {
        shift: commandes.shift,
      })
    }).finally(() => {
      if (rootState.commande.commandes.length > 0) {
        this._vm.$toast(String(`${SentenceUtils.pluralize(rootState.commande.commandes.length, ['Commande'])} ${SentenceUtils.pluralize(rootState.commande.commandes.length, ['chargée'])} pour le ${moment(date, 'YYYY-MM-DD').format('dddd DD/MM/YYYY')}`).replace(/ {2,}/g, ' '))
      }
      commit('setCommandesLoading', false)
    })
  },
  setCommandesLoading({ commit }, value) {
    commit('setCommandesLoading', value)
  },
  editCommande({ commit, dispatch, rootState }, commandeValue) {
    dispatch('loadDefaultCommandeData')
    const isNamed = commandeValue.prenom === 'Mr' || commandeValue.prenom === 'Mme' || commandeValue.prenom === 'Pro'
    commit('setNewCommande', {
      _id: commandeValue._id,
      idEmployees: commandeValue.idEmployees,
      nom: commandeValue.nom,
      date: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD'),
      heure: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('HH:mm'),
      dateLivraison: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD HH:mm:ss'),
      datePrise: commandeValue.datePrise,
      prenom: isNamed ? '' : commandeValue.prenom,
      civ: isNamed ? commandeValue.prenom : null,
      telephone: commandeValue.telephone,
      public: commandeValue.public,
      ready: commandeValue.ready,
      deleted: commandeValue.deleted,
      deletedBy: commandeValue.deletedBy,
      commentaires: commandeValue.commentaires,
      accompte: commandeValue.accompte,
      auxiliaire: commandeValue.auxiliaire,
      idLieuLivraison: commandeValue.idLieuLivraison,
      idCommande: commandeValue.idCommande,
    })
    if (isNamed) {
      commit('setCiv', commandeValue.prenom)
    }
    commit('setProducts', commandeValue.products.map(product => CommonUtils.createDictionnaryEntry(
      {
        ...product,
        code: {
          ...product.foundCode, text: product.text, idCode: product.idCode, idDenomination: product.idDenomination,
        },
        codesCommande: product.codeConditionnementCommande.length > 0 ? product.codeConditionnementCommande[0].map(code => ({ ...code, auxiliaire: commandeValue.auxiliaire })) : [],
      },
    )))
    const plateauxWithQuantite = rootState.commande.plateaux.map(plateau => {
      const commandePlateau = commandeValue.plateaux.find(commandep => commandep.idPlateau === plateau._id)
      if (commandePlateau) {
        return {
          ...plateau, idPlateau: plateau._id, _id: commandePlateau._id, idCommandePlateau: commandePlateau._id, quantite: commandePlateau.quantite, prix: commandePlateau.prix, montage: commandePlateau.montage,
        }
      }
      return { ...plateau, idPlateau: plateau._id, quantite: 0 }
    }).filter(plateau => !CommonUtils.toBoolean(plateau.custom) || (CommonUtils.toBoolean(plateau.custom) && plateau.quantite))
    commit('setPlateauxList', plateauxWithQuantite.map(plateau => CommonUtils.createDictionnaryEntry(plateau)))
    dispatch('showCommande', true)
  },
  removeCommande({ commit, rootState }, commandeValue) {
    const currentCommande = {
      _id: commandeValue._id,
      idEmployees: commandeValue.idEmployees,
      nom: commandeValue.nom,
      date: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD'),
      heure: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('HH:mm'),
      dateLivraison: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD HH:mm:ss'),
      datePrise: commandeValue.datePrise,
      prenom: commandeValue.prenom,
      telephone: commandeValue.telephone,
      public: commandeValue.public,
      ready: commandeValue.ready,
      deleted: commandeValue.deleted,
      deletedBy: commandeValue.deletedBy,
      commentaires: commandeValue.commentaires,
      accompte: commandeValue.accompte,
      auxiliaire: commandeValue.auxiliaire,
      idLieuLivraison: commandeValue.idLieuLivraison,
      idCommande: commandeValue.idCommande,
    }
    return Promise.all([
      CommandesService.upsertCommande({ ...currentCommande, deleted: true, deletedBy: commandeValue.deletedBy }),
      ...commandeValue.products.map(codeCommande => CommandesService.deleteCommandeCode(codeCommande)),
      ...commandeValue.plateaux.filter((flatPlateau) => flatPlateau.quantite > 0).map(plateauCommande => CommandesService.deleteCommandePlateau(plateauCommande)),
    ])
      .then(() => {
        commit('setCommandesOnUpdate', rootState.commande.commandes.map(commande => {
          if (commande._id === currentCommande._id) {
            return ({ ...commande, deleted: true, deletedBy: commandeValue.deletedBy })
          }
          return commande
        }))
      })
  },
  setCommandeState({ commit, rootState }, commandeValue) {
    const currentCommande = {
      _id: commandeValue._id,
      idEmployees: commandeValue.idEmployees,
      nom: commandeValue.nom,
      date: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD'),
      heure: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('HH:mm'),
      dateLivraison: moment(commandeValue.dateLivraison, 'DD/MM/YYYY [à] HH[h]mm').format('YYYY-MM-DD HH:mm:ss'),
      datePrise: commandeValue.datePrise,
      prenom: commandeValue.prenom,
      telephone: commandeValue.telephone,
      public: commandeValue.public,
      ready: commandeValue.ready,
      deleted: commandeValue.deleted,
      deletedBy: commandeValue.deletedBy,
      commentaires: commandeValue.commentaires,
      accompte: commandeValue.accompte,
      auxiliaire: commandeValue.auxiliaire,
      idLieuLivraison: commandeValue.idLieuLivraison,
      idCommande: commandeValue.idCommande,
    }
    return CommandesService.upsertCommande(currentCommande)
      .then(() => {
        commit('setCommandesOnUpdate', rootState.commande.commandes.map(commande => {
          if (commande._id === commandeValue._id) {
            return ({ ...commande, ready: commandeValue.ready })
          }
          return commande
        }))
      })
  },
  saveCommande({ commit, rootState, dispatch }) {
    const { commande } = rootState.commande
    const produits = CommonUtils.removeDictionnary(rootState.commande.products.filter((product) => product.value.quantite > 0))
    const plateaux = CommonUtils.removeDictionnary(rootState.commande.plateauxList)
    const deletedProducts = CommonUtils.removeDictionnary(rootState.commande.deletedProducts)
    const parsedCommande = {
      ...commande,
      dateLivraison: moment(`${commande.date} ${commande.heure}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm:ss'),
      datePrise: moment().format('YYYY-MM-DD'),
      ready: CommonUtils.toBoolean(commande.ready),
      public: CommonUtils.toBoolean(commande.public),
      idLieuLivraison: !Number.isInteger(commande.idLieuLivraison) ? '' : commande.idLieuLivraison,
      prenom: commande.prenom || rootState.commande.civ,
      lastUpdate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
    return CommandesService.upsertCommande(parsedCommande)
      .then((putResult) => {
        const plateauxCommande = CommandeUtils.flatPlateaux(plateaux, putResult.idCommande, commande.auxiliaire, putResult.commande_uuid)
        const productsCommande = CommandeUtils.flatProducts(produits, putResult.idCommande, commande.auxiliaire, putResult.commande_uuid)
        const deletedPlateau = plateauxCommande.filter((flatPlateau) => flatPlateau.quantite === 0 && flatPlateau.commande_uuid)
        return Promise.all([
          ...productsCommande.map(codeCommande => CommandesService.putCommandeCode(codeCommande)),
          ...plateauxCommande.filter((flatPlateau) => flatPlateau.quantite > 0).map(plateauCommande => CommandesService.putCommandePlateau(plateauCommande)),
          ...deletedPlateau.map(plateau => CommandesService.deleteCommandePlateau(plateau)),
          ...deletedProducts.map(product => CommandesService.deleteCommandeCode(product)),
        ]).then(() => Promise.all([
          ...productsCommande.map(product => product.codesCommande.filter(cond => cond.deleted && cond._id).map(codeToDelete => CommandesService.deleteCodeConditionnementCommande({ _id: codeToDelete._id, deleted: 'true' }))),
          ...productsCommande.map(product => product.codesCommande.filter(cond => !cond.deleted).map(c => CommandesService.putConditionnementCommande({ ...c, idCommandeCodeSync: product._id }))),
        ]).then(() => {
          dispatch('resetCommande')
          dispatch('loadCommandes', rootState.commande.date)
          dispatch('loadCalendar', rootState.commande.date)
        }).finally(() => {
          dispatch('showCommande', false)
          commit('setSavingCommande', false)
          this._vm.$toast.success(`Commande ${`${commande.auxiliaire} - ${putResult.idCommande}`} sauvegardée !`)
        }).catch(err => this._vm.$toast.success('Erreur pendant la prise de commande, veuillez réessayer', err)))
      })
  },
}
export default {
  state,
  actions,
  mutations,
}
